// docs: https://github.com/altostra/type-validations#readme
import { maybe, objectOf } from "@altostra/type-validations";
import { boolean, number, string } from "@altostra/type-validations/lib/primitives";

export const isPostEngagementAppGroupIdSurveyExportResponsesResult = objectOf({
  success: boolean,
  message: string,
  params: objectOf({
    landing_page_id: maybe(string),
    campaign_base_id: maybe(string),
    message_variation_id: maybe(string),
    start_date: maybe(number),
    end_date: maybe(number),
  }),
});
